import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Bueroaufloesung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Büroauflösung",
        keyword: "Büroauflösung Berlin",
        metaTitle: "Büroauflösung Berlin | Fachgerecht & Schnell | MIROS",
        metaDesc:
          "Professionelle Büroauflösung in Berlin. Demontage, Aktenvernichtung und besenreine Übergabe für Gewerbekunden.",
        heroSub:
          "Termingerechte Räumung Ihrer Gewerberäume inklusive zertifizierter Aktenvernichtung.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9016967e20d627a9d3de.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901bb2e956bc24f8ce86.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a659bec99fc9f3e99.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a967e20d627a9db4d.jpg",
        trustIntro:
          "Ein Firmenumzug oder eine Standortschließung erfordert exakte Planung. Der laufende Betrieb darf nicht gestört werden, und sensible Daten müssen sicher vernichtet werden. Wir räumen Ihre Büros effizient, demontieren IT-Infrastruktur fachgerecht und garantieren absolute Diskretion.",
        slug: "bueroaufloesung-berlin",
      }}
    />
  );
}
